/****** 1.0 JSHINT outside library definitions ******/
	/* global ScrollMagic */
	/* global TweenLite */
	/* global TweenMax */
	/* global TimelineMax */
	/* global imagesLoaded */
	/* global Power3 */
	/* global Linear */
	/* global Sine */
	/* global Clipboard */
/****** 2.0 Variable Declarations******/

$(document).on('click', '.women', function(){
	gtag('event', 'engagement', {
	  'event_category': 'generate_lead',
	  'event_label': 'Dress for Success'
	});
});

$(document).on('click', '.men', function(){
	gtag('event', 'engagement', {
	  'event_category': 'generate_lead',
	  'event_label': 'Career Gear'
	});
});

$(document).on('click', '.logo', function(){
	gtag('event', 'engagement', {
	  'event_category': 'select_content',
	  'event_label': 'imre'
	});
});